import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { notifyServiceWorkerUpdate } from './utils/app-update-events';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './view/App/App.js';

import { Provider as AlertProvider } from 'react-alert';

// import contexts.
import GlobalDataProvider from './context/global-data-provider';
import PostsListProvider from './context/posts-list-provider';
import CategoryPostsListProvider from './context/category-posts-list-provider';
import GCategoryPostsListProvider from './context/g-category-posts-list-provider';
import AdminProvider from './context/admin-context';
import MemberProvider from './context/member-context';
import QueryProvider from './query/QueryProvider';

const AlertTemplate = ({ style, options, message, close }) => {
  let type = options.type;
  if (type === 'error') {
    type = 'danger';
  }

  return (
    <div style={style} className={`g-alert alert-${type} alert-dismissible mb-0`}>
      <div className="close" onClick={close}>
        <span>×</span>
      </div>
      {message}
    </div>
  );
};
const alertOptions = {
  position: 'top right',
  timeout: 8000,
  offset: '0',
  transition: 'scale',
  containerStyle: {
    zIndex: '5000',
  },
  template: AlertTemplate,
};

ReactDOM.render(
  <Router>
    {/*<Router basename={'nbco-server'}>*/}
    <CookiesProvider>
      <AlertProvider {...alertOptions}>
        <QueryProvider>
          <AdminProvider>
            <MemberProvider>
              <GlobalDataProvider>
                <PostsListProvider>
                  <CategoryPostsListProvider>
                    <GCategoryPostsListProvider>
                      <App />
                    </GCategoryPostsListProvider>
                  </CategoryPostsListProvider>
                </PostsListProvider>
              </GlobalDataProvider>
            </MemberProvider>
          </AdminProvider>
        </QueryProvider>
      </AlertProvider>
    </CookiesProvider>
  </Router>,
  document.getElementById('app-root'),
);

serviceWorker.register({
  onUpdate: (registration) => {
    notifyServiceWorkerUpdate(registration);
  },
});
